<template>
  <div>
    <CRow>
        <CCol>
            <div style="width:100%; height: 75vh;">
                <ejs-grid ref='gridscl' :dataSource='spotConfigLogsData' :allowFiltering='true' :allowPaging='true' :allowResizing='true'
                          :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :enablePersistence="true"
                          :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionBegin='actionBegin' 
                          :actionFailure="actionFailure" :actionComplete="actionComplete" :excelQueryCellInfo='excelQueryCell' :queryCellInfo='queryCell'
                          :allowExcelExport='true' :excelExportComplete='excelExportComplete' width="100%" height="100%">
                    <e-columns>
                        <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='spotConfigId' headerText='Spot Congfig Id' width=120></e-column>
                        <e-column field='ric' headerText='Identifier' textAlign='Left' width=130 type="string"></e-column>
                        <e-column field='stateName' headerText='Country' textAlign='Left' width=150 type="string"></e-column>
                        <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' width=150 type="string"></e-column>
                        <e-column field='utilityTypeName' headerText='Commodity' textAlign='Left' width=150 type="string"></e-column>
                        <e-column field='productName' headerText='Product' textAlign='Left' width=150 type="string"></e-column>
                        <e-column field='providerTypeName' headerText='Provider Type' textAlign='Left' width=150 type="string"></e-column>
                        <e-column field='description' headerText='Description' width=180></e-column>
                        <e-column field='logDate' headerText='Log Date' textAlign='Left' width=190 type="date" :format='dateFormatOptions'></e-column>
                        <e-column field='logTime' headerText='Log Time' textAlign='Left' type='string' width=150></e-column>
                        <e-column field='userName' headerText='User' textAlign='Left' width=150 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
  </div>
</template>
<script>

    import Vue from "vue";
    import { GridPlugin, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import axios from 'axios';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    export default {
        name: 'SpotConfigLogs',
        data() {
            return {
                store: store,
                spotConfigLogsData: SyncHelper.getDataManager("spotConfigLog"),
                pageSettings: gridOptions.pageSettings,
                toolbar: ['ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } }
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "SpotConfigurationLogs.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridscl.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
              
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            queryCell(args) {

                if (args.column.field === 'logTime') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['logTime']);
                }
                if (args.column.headerText === 'Log Date') {
                    args.value = this.formatDate(args.data['logDate']);
                }
            },
            excelQueryCell: function (args) {

                if (args.column.headerText === 'Log Time') {
                    args.value = this.convertUTCDateToLocalTime(args.data['logDate']);
                }
                if (args.column.headerText === 'Log Date') {
                    args.value = this.convertUTCDateToLocaDate(args.data['logDate']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            convertUTCDateToLocaDate(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleDateString();
            },
            formatDate(dateString) {
                const date = new Date(dateString)
                return date.toLocaleDateString();
            },
        },
        provide: {
            grid: [Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport]
        }
    }
</script>